module.exports = __webpack_public_path__ + "static/media/one_point_five.8f49984f.png";